import { createSelector } from "@reduxjs/toolkit";

export const appInitSlice = state => state.appInit

export const isAppInitialized = createSelector(
  appInitSlice,
  appInit => appInit.initialized
)